// @ts-strict-ignore
import { McsGdsBaseProjectHelper } from '@project/helper/mcs-gds-base-project.helper';
import { UserVO } from '@user/model/vo/user.vo';
import { Injectable } from '@angular/core';
import { ProjectType } from '../model/project-type';
import { IResponsibleForProjectTypeHelper } from './i-project.helper';

@Injectable({ providedIn: 'root' })
export class GdsProjectHelper extends McsGdsBaseProjectHelper implements IResponsibleForProjectTypeHelper {
  public isReplaceWithDifferentWidthAllowed(): boolean {
    return true;
  }

  public isDisplayOfProjectStructureEnabled(user: UserVO = null): boolean {
    return (
      this.checkUserPermission(user, "VIEW_PROJECT_STRUCTURE_IN_GDS_PROJECT")
    );
  }

  public isCopyPasteAllowed(): boolean {
    return true;
  }

  public userHasPermissionToDeleteMainPartComplexArticle(): boolean {
    return this.projectModel.user.hasPermission("DELETE_MAIN_PART_OF_COMPLEX_ARTICLE_IN_GDS_PROJECT");
  }

  public isResponsible(projectType: ProjectType): boolean {
    return projectType === "GDS";
  }
}
